<template>
  <div class="emptyContent">
      <div>
         <img :src="emptyImg" class="emptyImg" alt="" srcset="">
         <span>暂无数据</span>
      </div>
    </div>
</template>
<script>
import emptyImg from '@img/empty.png'
export default {
  data () {
    return {
      emptyImg
    }
  }
}
</script>
<style lang='less' scoped>
   .emptyContent{
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      font-size: 16px;
      .emptyImg{
        width: 70px;
      }
    }
</style>
